import type { ReactNode } from 'react';

import { XingletLoader } from '@xing-com/crate-xinglet';

export const Component = (): ReactNode => {
  return <XingletLoader name="@xing-com/crate-communication-root" />;
};
